import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ECOPortalIntegrationState = {
  eco_portal: {
    exports: [],
    paginator: null,
    apiLoading: false,
    enabled: false,
  },
}

export const ECOPortalIntegrationActions = {
  fetchEcoPortalExports: async ({ commit }, params = {}) => {
    commit('setEcoPortalIntegrationApiLoading', true)

    return axiosRequest.get('/admin/eco_portal/exports', { params }).
      then(({ data }) => {
        commit('setEcoPortalIntegrationExports', data?.table || [])
        commit('setEcoPortalIntegrationPaginator', data?.paginator || null)
      }).
      catch(handleError).
      finally(_ => commit('setEcoPortalIntegrationApiLoading', false))
  },
  checkEcoPortalEnabled: async ({ commit }) => {
    return axiosRequest.get('/admin/eco_portal/enabled').
      then(({ data }) => {
        commit('setEcoPortalEnabled', data?.enabled || false)
      }).
      catch(handleError)
  },
}

export const ECOPortalIntegrationGetters = {
  ecoPortalIntegrationApiLoading: state => state.eco_portal.apiLoading,
  ecoPortalIntegrationExports: state => state.eco_portal.exports,
  ecoPortalIntegrationPaginator: state => state.eco_portal.paginator,
  ecoPortalEnabled: state => state.eco_portal.enabled,
}

export const ECOPortalIntegrationMutations = {
  setEcoPortalIntegrationApiLoading: (state, data) => (state.eco_portal.apiLoading = data),
  setEcoPortalIntegrationExports: (state, data) => (state.eco_portal.exports = data),
  setEcoPortalIntegrationPaginator: (state, data) => (state.eco_portal.paginator = data),
  setEcoPortalEnabled: (state, data) => (state.eco_portal.enabled = data),
}
